export var ANNOUNCEMENT_EVENT_NAME = 'announcement';
export var ARIA_ANNOUNCER_ID = 'aria-announcer';
export var ARIA_ANNOUNCER = 'aria-announcer';